import { useState, useCallback } from 'react';

export interface UsePanelManagementReturn {
  isDriveOpen: boolean;
  setIsDriveOpen: (value: boolean) => void;
  handleOpenDrive: () => void;
  handleCloseAllPanels: () => void;
}

/**
 * Hook para gestionar el estado de los paneles laterales
 *
 * Maneja:
 * - Estado de paneles abiertos (Drive)
 * - Funciones para abrir/cerrar paneles
 */
export function usePanelManagement(): UsePanelManagementReturn {
  const [isDriveOpen, setIsDriveOpen] = useState(false);

  const handleOpenDrive = useCallback(() => {
    setIsDriveOpen(true);
  }, []);

  const handleCloseAllPanels = useCallback(() => {
    setIsDriveOpen(false);
  }, []);

  return {
    isDriveOpen,
    setIsDriveOpen,
    handleOpenDrive,
    handleCloseAllPanels,
  };
}















